import { ISelectComPesquisaProps, SelectComPesquisa } from "@/Components/SelectComPesquisa";
import { EnumDocumentoTipo } from "@/Models/Pessoa/Pessoa";

export interface IAlunoDocumentoTipoSelectProps extends ISelectComPesquisaProps {

}

export default function AlunoDocumentoTipoSelect({
    placeholder,
    ...rest
}:IAlunoDocumentoTipoSelectProps) {
    return <SelectComPesquisa
        {...rest}
        placeholder={placeholder === undefined ? "Selecione" : placeholder}
        options={[
            {
                value: EnumDocumentoTipo.CPF,
                label: "CPF",
            },
            {
                value: EnumDocumentoTipo.Passaporte,
                label: "Passaporte",
            },
            {
                value: EnumDocumentoTipo.RNE,
                label: "RNE"
            },
        ]}
    />
}